const initialState = {
  isTrue: false,
};

const cityDropdownReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case "cityTrue":
      return {
        ...state,
        isTrue: payload,
      };
    default:
      return state;
  }
};

export default cityDropdownReducer;
